import { Typography } from "@mui/material"

export function PdfTaskOrderHeader({ label, align = "left" }) {
    return (
        <Typography
            sx={{
                fontWeight: 700,
                fontSize: "10px",
                color: "#4b5563",
                py: "10px",
                borderBottom: "1px solid #d7dce2",
                textAlign: align,
            }}
        >
            {label}
        </Typography>
    )
}
